import request from "@/utils/request.js"

// 摄影师-新增(跨租户)
export const addPhotographyIgnore = (formData) => {
    return request.post(`/photography/ignoreTenant`, formData)
}

// 摄影师-详情(跨租户)
export const getPhotographyIgnore = (id) => {
    return request.get(`/photography/ignoreTenant/${id}`)
}

// 摄影师-修改(跨租户)
export const updatePhotographyIgnore = (updateData) => {
    return request.put(`/photography/ignoreTenant`, updateData);
};
